import React, { useState } from 'react';
import ListaPacientes from './ListaPacientes';
import FormPaciente from './FormPaciente';

interface GerenciarPacientesProps {
  onPacienteChange?: () => void;
}

const GerenciarPacientes: React.FC<GerenciarPacientesProps> = ({ onPacienteChange }) => {
  const [view, setView] = useState<'lista' | 'form'>('lista');
  const [pacienteEditando, setPacienteEditando] = useState<string | undefined>();

  const handleNovoPaciente = () => {
    setPacienteEditando(undefined);
    setView('form');
  };

  const handleEditarPaciente = (id: string) => {
    setPacienteEditando(id);
    setView('form');
  };

  const handleVoltar = () => {
    setPacienteEditando(undefined);
    setView('lista');
  };

  const handleSalvar = () => {
    // Após salvar, volta para a lista e atualiza contador
    setPacienteEditando(undefined);
    setView('lista');
    onPacienteChange?.();
  };

  return (
    <>
      {view === 'lista' ? (
        <ListaPacientes 
          onNovoPaciente={handleNovoPaciente}
          onEditPaciente={handleEditarPaciente}
          onPacienteChange={onPacienteChange}
        />
      ) : (
        <FormPaciente 
          pacienteId={pacienteEditando}
          onVoltar={handleVoltar}
          onSalvar={handleSalvar}
        />
      )}
    </>
  );
};

export default GerenciarPacientes;